import { render, staticRenderFns } from "./GroupOverview.vue?vue&type=template&id=1fe7d0a4&scoped=true&"
import script from "./GroupOverview.vue?vue&type=script&lang=js&"
export * from "./GroupOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupOverview.vue?vue&type=style&index=0&id=1fe7d0a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7d0a4",
  null
  
)

export default component.exports